import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

// Vistas previas del taller de un proyecto: ¿es un proyecto del taller? y ¿hay una en marcha?
export function usePreviewInfo(projectId) {
  return useQuery({
    queryKey: ["previews", projectId],
    queryFn: async () => (await apiClient.get("/workshop/previews", { params: { project_id: projectId } })).data,
    enabled: !!projectId,
    retry: false,
  });
}

// Botón «Previsualizar»: reabre la última vista previa (la arranca de nuevo si se apagó por inactividad).
export function useRestartPreview(projectId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => (await apiClient.post("/workshop/previews/restart", { project_id: projectId })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["previews", projectId] }),
  });
}
